import {put, call, takeLatest, select} from 'redux-saga/effects';
import cmsApi from '../api/cms.api';
import * as ActionTypes from '../actions/types.action';
import {DEFAULT_BRANCH} from '../constants/constants';

function* getBanners() {
  const getBranch = state => state.branch;
  const branchId = yield select(getBranch);
  const branch = branchId || DEFAULT_BRANCH;
  try {
    const banners = yield call(cmsApi.getBanners);
    yield put({
      type: ActionTypes.GET_CMS_BANNERS_SUCCESS,
      banners,
      branch,
    });
  } catch (e) {
    yield put({
      type: ActionTypes.GET_CMS_BANNERS_FAILED,
      message: e.message,
    });
  }
}

function* getVacancies() {
  try {
    const vacancies = yield call(cmsApi.getVacancies);
    yield put({
      type: ActionTypes.GET_CMS_VACANCIES_SUCCESS,
      vacancies,
    });
  } catch (e) {
    yield put({
      type: ActionTypes.GET_CMS_VACANCIES_FAILED,
      message: e.message,
    });
  }
}

function* getDepartments() {
  try {
    const departments = yield call(cmsApi.getDepartments);
    yield put({
      type: ActionTypes.GET_CMS_DEPARTMENTS_SUCCESS,
      departments: departments && departments.Departments,
    });
  } catch (e) {
    yield put({
      type: ActionTypes.GET_CMS_DEPARTMENTS_FAILED,
      message: e.message,
    });
  }
}

export default function* getCmsDataYield() {
  yield takeLatest(ActionTypes.GET_CMS_BANNERS_REQUESTED, getBanners);
  yield takeLatest(ActionTypes.GET_CMS_VACANCIES_REQUESTED, getVacancies);
  yield takeLatest(ActionTypes.GET_CMS_DEPARTMENTS_REQUESTED, getDepartments);
}
